import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ profile, onEditPhoto, onEditProfile }) => {
  return (
    <div className="bg-card rounded-xl shadow-md overflow-hidden">
      <div className="relative h-32 md:h-40 lg:h-48 bg-gradient-to-r from-primary to-secondary">
        <div className="absolute inset-0 bg-black/10" />
      </div>
      <div className="relative px-4 md:px-6 lg:px-8 pb-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 -mt-16 md:-mt-20 lg:-mt-24">
          <div className="flex flex-col sm:flex-row items-center sm:items-end gap-4">
            <div className="relative group">
              <div className="relative w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 rounded-full border-4 border-card shadow-xl overflow-hidden bg-muted">
                <Image
                  src={profile?.avatar}
                  alt={profile?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <button
                onClick={onEditPhoto}
                className="absolute bottom-2 right-2 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-accent text-accent-foreground rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-smooth hover-lift press-scale"
                aria-label="Change profile photo"
              >
                <Icon name="Camera" size={20} />
              </button>
            </div>
            
            <div className="text-center sm:text-left mb-4 sm:mb-0">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
                {profile?.name}
              </h1>
              <p className="text-sm md:text-base text-muted-foreground mt-1">
                Member since {profile?.memberSince}
              </p>
              <div className="flex items-center justify-center sm:justify-start gap-2 mt-2">
                <div className="flex items-center gap-1 px-3 py-1 bg-success/10 text-success rounded-full">
                  <Icon name="CheckCircle" size={16} />
                  <span className="text-xs md:text-sm font-medium caption">
                    {profile?.membershipType}
                  </span>
                </div>
                <div className="flex items-center gap-1 px-3 py-1 bg-accent/10 text-accent rounded-full">
                  <Icon name="Flame" size={16} />
                  <span className="text-xs md:text-sm font-medium caption">
                    {profile?.streakDays} Day Streak
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex items-center justify-center gap-2 w-full lg:w-auto">
            <Button
              variant="outline"
              size="default"
              iconName="Share2"
              iconPosition="left"
              className="flex-1 lg:flex-none"
            >
              Share Profile
            </Button>
            <Button
              variant="default"
              size="default"
              iconName="Edit"
              iconPosition="left"
              onClick={onEditProfile}
              className="flex-1 lg:flex-none"
            >
              Edit Profile
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;